import React, { Component } from 'react'

export default class OtherPotentialCauses extends Component {
  constructor(props){
    super(props)

    this.state = {
      selectedOption:{
        id:0,
        Name:"",
        Slide:0,
        Selected:false
      },
      options: [{
          id:1,
          Name:"Over the age of 65",
          Slide:26,
          Selected:false
        },
        {
          id:2,
          Name:"Nerve damage",
          Slide:27,
          Selected:false
        },
        {
          id:3,
          Name:"Anxiety",
          Slide:29,
          Selected:false
        },{
          id:4,
          Name:"Degenerative disease",
          Slide:27,
          Selected:false
        },{
          id:5,
          Name:"Medications",
          Slide:28,
          Selected:false
        },{
          id:6,
          Name:"Dizziness, but no spinning",
          Slide:29,
          Selected:false
        },{
          id:7,
          Name:"Sensitive to visual images",
          Slide:29,
          Selected:false
        },{
          id:8,
          Name:"None of these",
          Slide:30,
          Selected:false
        }
      ]
    }
  }

  onSelection = (selectedOption) =>{
    // this.setState((prevState) => {
    //   prevState.options[index].Selected = !prevState.options[index].Selected;
    //   return {...prevState};
    // })
    this.setState({
      selectedOption
    })
  } 

  onInnerClick = () => {
    const {selectedOption} = this.state;
    const {onClick} = this.props;

    if(selectedOption.Slide === 0){
        alert("Please select one option atleast");
        return;
    }

    onClick(selectedOption.Slide,true);



  }
  
  render() {

    const {options, selectedOption} = this.state;
   

    return (
        <div>
           
          
          <div className="">
              <p>Making it here means we’ve ruled out more serious causes of dizziness.</p>

              <p>There are a lot of things that can cause dizziness including things like medication side effects, stress, dehydration, aging, degenerative diseases like Parkinson’s or Multiple Sclerosis, or nerve damage caused by diabetes or another condition.</p>
              <h2 >Which of the following is applicable?</h2>
              <div className="row text-center other-options"> 
              {options.map((option, i) => {
               return <button className={"col-lg-3 btn m-1 col-5 " + (selectedOption.id === option.id? "btn-dark" : "btn btn-outline-dark")} key={i}  onClick={this.onSelection.bind(this,option)}>
               {/* {selectedOption.id === option.id && <span className="float-left"><Checkbox/></span> } */}
               {option.Name} 
               </button>
              })}
              <button className="btn btn-danger col-lg-3 btn m-1"   onClick={this.onInnerClick}>Next</button>

              </div>

         
          </div>
         
        </div>

    )
  }
}
